import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PublisherService } from '../../../../../../services/publisher.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Publisher } from '../../../../../../models/publisher';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';

@Component({
    selector: 'app-update-publisher',
    templateUrl: './update-publisher.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdatePublisherComponent extends BaseComponent implements OnInit {
    publisher: Publisher = new Publisher();

    constructor(
        private publisherService: PublisherService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.publisher.id = route.snapshot.params['id'];
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.getPublisher();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    getPublisher() {
        Helpers.setLoading(true);
        this.publisherService.find(this.publisher.id).subscribe(res => {
            this.publisher = res.data;
            Helpers.setLoading(false);
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    updatePublisher() {
        var _self = this;
        Helpers.setLoading(true);
        this.publisher.phone = (<any>$('#phone')).val();
        this.publisherService.update(this.publisher).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.router.navigate(['/owner/publisher/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/publishers/update-publisher/update-publisher.component.ts